import { render, staticRenderFns } from "./UploadRecordStatus.vue?vue&type=template&id=58bb7347&scoped=true&"
import script from "./UploadRecordStatus.vue?vue&type=script&lang=ts&"
export * from "./UploadRecordStatus.vue?vue&type=script&lang=ts&"
import style0 from "./UploadRecordStatus.vue?vue&type=style&index=0&id=58bb7347&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb7347",
  null
  
)

export default component.exports